import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import type { RouterOutputs } from "@/trpc";
import type { WeekKey } from "@/features/time-entry/utils/week-utils";

export type ApprovedExpense =
  RouterOutputs["expense"]["getApprovedExpensesForOrg"][number];

/**
 * Hook to fetch approved (historical) expenses for organization.
 * Returns a flat array of expenses.
 */
export function useApprovedExpenses(params: {
  organizationBusinessUnitId: string;
  weekKey?: WeekKey;
  facilityId?: string;
  providerSearch?: string;
}) {
  const trpc = useTRPC();

  const {
    data: expenses,
    isLoading,
    error,
    refetch,
  } = useQuery(
    trpc.expense.getApprovedExpensesForOrg.queryOptions({
      organizationBusinessUnitId: params.organizationBusinessUnitId,
      weekKey: params.weekKey,
      facilityId: params.facilityId,
      providerSearch: params.providerSearch,
    }),
  );

  return {
    expenses: (expenses ?? []) as ApprovedExpense[],
    isLoading,
    error,
    refetch,
  };
}
